import React, { useEffect, useState } from 'react'

import { useConsumerCart, useShop } from 'shop/hooks'
import { CheckoutCartLoaderProps } from './types'
import { useNavigate } from 'react-router-dom'
import { ConsumerCart } from 'shop/types/cart'
import { ApolloError } from '@apollo/client'
import { checkHandleUnauthorizedError, returnToShop } from 'shop/utils/common'
import { getCurrentCartId } from 'shop/utils/cart'
import { Loading } from '../Loading'

export const CheckoutCartLoader = ({
  isParentLoaded = true,
  children
}: CheckoutCartLoaderProps) => {
  const { config, currentPartnerStore } = useShop()
  const { domain } = config
  const navigate = useNavigate()
  const {
    getConsumerCart,
    cart: consumerCart,
    validateCart
  } = useConsumerCart()
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [inProgress, setInProgress] = useState(false)
  const [cart, setCart] = useState<ConsumerCart>()
  const cartId = consumerCart?.id || getCurrentCartId(config.domain)

  useEffect(() => {
    if (!isParentLoaded) return
    const fetchData = async () => {
      if (!isLoaded && !inProgress && cartId) {
        return getConsumerCart()
          .then((res: ConsumerCart | null) => {
            if (res) {
              setCart(res)
            }
            // Validate cart when consumer cart load
            validateCart(false).then(() => {
              setIsLoaded(!!res)
              setInProgress(false)
            })
          })
          .catch((error: ApolloError) => {
            checkHandleUnauthorizedError(
              error,
              domain,
              currentPartnerStore?.slug,
              navigate
            )
            setInProgress(false)
            returnToShop(currentPartnerStore?.slug, navigate)
          })
      }

      // If no cart id is to be found then return to shop
      if (!isLoaded && !inProgress && !cartId) {
        returnToShop(currentPartnerStore?.slug, navigate)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isParentLoaded])

  return (
    <React.Fragment>
      {cart ? children(isLoaded, cart) : <Loading />}
    </React.Fragment>
  )
}
